module.exports = __webpack_public_path__ + "img/next.d1392ca7.svg";